import * as React from "react";
import { withTranslation } from "react-i18next";
import { InputFormField } from "../common/hook-form/InputFormField";
import { SelectFormField } from "../common/hook-form/SelectFormField";
import { useForm } from "react-hook-form";
import { PrimaryButton } from "../../components/Buttons";
import { colors } from "../../components/colors";
import { StyledText } from "../../assets/typography/typography";

interface Props {
  onSearch: (values: any) => void;
  onReset: () => void;
  defaultFilters: {
    disabled: string;
    visible: string;
  };
}

const MemberCardTypeListFilterForm: React.FC<Props> = (props) => {
  const formMethods = useForm({
    defaultValues: props.defaultFilters,
  });
  const yesNoOptions = [
    { label: "Any", value: "" },
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  return (
    <form className="card" onSubmit={formMethods.handleSubmit(props.onSearch)}>
      <div className="card-header border-bottom-0 mt-4 justify-content-between">
        <StyledText
          color={colors.textPrimary}
          className="bodyHeaderOneSemi card-title"
        >
          Search for membercard template
        </StyledText>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            {/* @ts-ignore */}
            <InputFormField
              label="Name"
              name="name"
              defaultValue={""}
              errors={formMethods.formState.errors}
              register={formMethods.register}
            />
          </div>
          <div className="col-md-6">
            <InputFormField
              label="Online Pos Group"
              name="onlinePosGroup"
              defaultValue={""}
              errors={formMethods.formState.errors}
              register={formMethods.register}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <SelectFormField
              options={yesNoOptions}
              errors={formMethods.formState.errors}
              register={formMethods.register}
              clearErrors={formMethods.clearErrors}
              label="Show Triple Up"
              name="showTripleUp"
            />
          </div>
          <div className="col-md-4">
            <SelectFormField
              options={yesNoOptions}
              errors={formMethods.formState.errors}
              register={formMethods.register}
              clearErrors={formMethods.clearErrors}
              label="Is visible"
              name="visible"
            />
          </div>
          <div className="col-md-4">
            <SelectFormField
              options={yesNoOptions}
              errors={formMethods.formState.errors}
              register={formMethods.register}
              clearErrors={formMethods.clearErrors}
              label="Is disabled"
              name="disabled"
            />
          </div>
        </div>
      </div>
      <div className="card-footer d-flex pt-0 border-top-0 justify-content-between">
        <PrimaryButton
          backgroundColor={colors.transparent}
          hoverColor={colors.ctaLight}
          color={colors.ctaMain}
          type="button"
          onClick={() => {
            formMethods.reset();
            props.onReset();
          }}
        >
          Reset
        </PrimaryButton>
        <PrimaryButton
          backgroundColor={colors.ctaMain}
          hoverColor={colors.ctaSecondaryOne}
          color={colors.white}
          type="submit"
        >
          Search
        </PrimaryButton>
      </div>
    </form>
  );
};

export default withTranslation()(MemberCardTypeListFilterForm);
